/**
 * This patch extends jQuery's `.trigger()` method to also dispatch native DOM events
 * for certain event types (e.g., 'change', 'input', 'click'). This allows jQuery-based
 * code that programmatically triggers events using `.trigger()` to be compatible with
 * native DOM event listeners.
 *
 * This is particularly useful during migration from legacy inline event handlers
 * (e.g., `onchange="..."`) to CSP-compliant delegated handlers based on
 * `data-on*` attributes, as implemented in `delegated-event-handler.js`.
 *
 * Without this patch, jQuery's `.trigger('change')` will only invoke jQuery's internal
 * event system and not dispatch a real DOM event — which means delegated event handlers
 * attached via `document.addEventListener(...)` (such as in `delegated-event-handler.js`)
 * would not fire.
 *
 * By dispatching a native `Event` alongside the jQuery `.trigger()`, this patch ensures
 * compatibility with both:
 *   - jQuery handlers registered via `.on('change', ...)`
 *   - Native or delegated handlers listening on the DOM (including those relying on
 *     `data-onchange` or similar attributes)
 *
 * This is a temporary compatibility bridge for CSP-safe event delegation, and can be
 * removed once jQuery is phased out or all event triggering is rewritten to use
 * `dispatchEvent()` directly.
 */
(function ($) {
  if (!$ || !$.fn || !$.fn.trigger) return;
  const originalTrigger = $.fn.trigger;

  $.fn.trigger = function (type, ...args) {
    // Call the original jQuery trigger function
    const result = originalTrigger.apply(this, [type, ...args]);

    // For specific event types, also dispatch a native DOM event
    const nativeEvents = ['change', 'input', 'click', 'focus', 'blur', 'submit'];
    if (nativeEvents.includes(type)) {
      this.each(function () {
        try {
          // Only dispatch native events on actual DOM elements or relevant global objects
          if (this instanceof Element || this === window || this === document) {
            const nativeEvent = new Event(type, { bubbles: true, cancelable: true });
            this.dispatchEvent(nativeEvent);
          }
        } catch (e) {
          console.error(`Failed to dispatch native "${type}" event on:`, this, e);
        }
      });
    }
    return result;
  };
})(window.jQuery);
